import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import type { ReactNode } from "react";

import { PAGE_SURFACE } from "@/react/constants/pageSurface";
import { classNames } from "@/react/helpers/twMergeWithCN";

import { CanvasHeaderRow } from "./CanvasHeaderRow";

interface CanvasHeaderProps {
  alwaysVisible?: boolean;
  breadcrumb?: ReactNode;
  rightActions?: ReactNode;
}

export const CanvasHeader = ({
  alwaysVisible = false,
  breadcrumb,
  rightActions,
}: CanvasHeaderProps) => {
  const conversationPanelState = useCircleAIShellStore(
    s => s.conversationPanelState,
  );
  const isPanelOpen = conversationPanelState !== "closed";
  const isVisible = isPanelOpen || alwaysVisible;

  return (
    <div
      aria-hidden={!isVisible || undefined}
      inert={!isVisible || undefined}
      className={classNames(
        "shrink-0 overflow-hidden [transition:height_280ms_cubic-bezier(0.77,0,0.175,1),opacity_160ms_cubic-bezier(0.23,1,0.32,1)] motion-reduce:[transition:opacity_120ms_cubic-bezier(0.23,1,0.32,1)]",
        !isPanelOpen && PAGE_SURFACE,
        {
          "rounded-t-lg bg-secondary": isPanelOpen,
          "lg:border-b": isVisible && !isPanelOpen,
          "lg:border-secondary": alwaysVisible && !isPanelOpen,
          "h-[52px] opacity-100": isVisible,
          "h-0 opacity-0": !isVisible,
        },
      )}
    >
      <CanvasHeaderRow breadcrumb={breadcrumb} rightActions={rightActions} />
    </div>
  );
};

CanvasHeader.displayName = "CanvasHeader";
